import React, { useEffect, useRef, useState } from 'react';
import { useVideoService } from '../../contexts/VideoServiceContext';
import './Video.css';

const Video = () => {
  const videoRef = useRef(null);
  const [error, setError] = useState(null);
  const videoService = useVideoService();

  useEffect(() => {
    const handleStreamChange = (stream) => {
      if (videoRef.current) videoRef.current.srcObject = stream || null;
    };
    const unsubscribeStream = videoService.onStreamChange(handleStreamChange);
    const unsubscribeError = videoService.onError(err => {
      if (err?.name === 'NotAllowedError') {
        setError('Camera access was denied. Enable camera permission to stream workouts.');
      } else {
        setError(err?.message || 'Workout camera is unavailable.');
      }
    });
    return () => {
      unsubscribeStream();
      unsubscribeError();
    };
  }, [videoService]);

  return (
    <div className="video-container">
      {error && <div className="video-error-message" role="alert">{error}</div>}
      <video ref={videoRef} autoPlay playsInline muted className="video-element" aria-label="Your live workout camera preview" />
    </div>
  );
};

export default Video;
